import React, {Fragment, useEffect, useRef, useState} from 'react'
import axios, * as others from 'axios';
import {Link, useLoaderData, useLocation, useParams} from "react-router-dom";
import {

    adminVenueCard,
    audienceButtons,
    changeAttribute,
    getAttribute,
    getImageWithPrefix,
    getLocalDate,
    hasAttribute,
    isDev,
    loader,
    relatedSchemaArtistCard,
    setAttribute,
    setRoomAttribute,
    setUniqueEventAttribute,
    smallArtistCard,
    smallEventCard,
    smallVenueCard,
    toastSuccess
} from "../../components/common/utilities";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import MainNavigation from "../../components/common/navigation.component";
import {DateTimePicker, LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import 'moment/locale/en-gb';
import SidebarNavigation from "../../components/common/sidebarnavigation.component";
import MediaCollection from "../media/mediaCollection";
import {Dialog, Field, Label, Switch, Transition} from "@headlessui/react";
import mapboxgl from "mapbox-gl";
import {Geocoder} from '@mapbox/mapbox-sdk';
import {ChevronRightIcon} from "@heroicons/react/20/solid";
import Map, {GeolocateControl, Marker} from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import {ToastContainer} from "react-toastify";
import {XMarkIcon} from "@heroicons/react/24/outline";
import FindVenues from "../venues/findVenues";
import CreateEvent from "./createEvent";
import FindEvents from "./findEvents";
import {ArrowLongLeftIcon, ArrowLongRightIcon, ChevronDoubleLeftIcon} from "@heroicons/react/16/solid";

function classNames(...classes: any[])
{
    return classes.filter(Boolean).join(' ')
}

export default function UpcomingEvents({artist, venue}: any) {
    let params = useParams();
    const venueID = params.venueID;
    const data = useLoaderData() as any;
    //console.log("params", params);

    type SchemaEvent = {
        [key: string]: any; // ?? variable key
        name: string;
    };

    const text = useRef("");
    const inFocus = useRef("");
    const [artists, setArtists] = useState(data.artists);
    const [photos, setPhotos] = useState([]);
    let [loading, setLoading] = useState(true);
    let [color, setColor] = useState("#ffffff");
    const [date, setDate] = useState(null)
    const [venueData, setVenueData] = useState<SchemaEvent>();
    const [showMedia, setShowMedia] = useState(false);
    const [wholeDay, setWholeDay] = useState(false);
    const [lang, setLang] = useState(getLang());
    const [open, setOpen] = useState(false);

    const [events, setEvents] = useState([]);
    const [nextOffset, setNextOffset] = useState("");
    const [prevOffset, setPrevOffset] = useState("");
    const [showLoader, setShowLoader] = useState(false);

    function getLang()
    {
        if (navigator.languages != undefined) return navigator.languages[0];
        return navigator.language;
    }

    mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

    //console.log('access token', process.env.REACT_APP_MAPBOX_TOKEN);

    const getEvents = nextOffset => {
        setShowLoader(true)
        let partner = "9b48bfd5397dfc5265d001b95b07466e";
        if(isDev())
        {
            partner = "db417ddadcf657020749024b327c6e6e";
        }

        let path = '/v1/partner/'+partner+'/performer/'+artist+'/events';
        if(venue)
        {
            path = '/v1/partner/'+partner+'/venue/'+venue+'/events';

        }

        axios.get(`${process.env.REACT_APP_CLOUDAPI_URL}`+path, {
            params: {
                limit: 12, offset: nextOffset
            }

        }).then(function (response) {
            // handle success
            console.log("events", response);
            setShowLoader(false)
            setEvents(response.data.collection);
            setNextOffset(response.data.pagination.nextOffset);
            setPrevOffset(response.data.pagination.previousOffset);

        });
    }

    const getNext = () => {
        console.info("getNext()"+nextOffset);
        getEvents(nextOffset);
    }
    const getPrevious = () => {
        getEvents(prevOffset);
    }

    const getFirst = () => {
        getEvents("");
    }

    const toggleMedia = () => {
        if (showMedia)
        {
            setShowMedia(false);
        }
        else
        {
            setShowMedia(true);
        }
    }

    useEffect(() => {
        getEvents("");
        //getVenue();
        //getPhotos();
        //handleArtists(data);

    }, []);

    const pagedata = useLoaderData() as any;
    let faceguid = '';

    function clickedEvent(e)
    {
        console.log("clicked", e.target);

        let button = e.target.dataset.button;
        if (button === 'mediaSelected')
        {
            console.log('settingMedia');
            let media = e.target.dataset.media;
            setVenueData({
                             ...venueData, image: media
                         });


            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            //setUniqueEventAttribute(key,value,unique,remove,eventid);

            toastSuccess('Event updated');

        }
        else if (button === 'setPrivate')
        {
            console.log('setting private');
            let key = e.target.dataset.key;
            let value = e.target.dataset.value;
            let unique = e.target.dataset.unique;
            let remove = e.target.dataset.remove;
            let eventid = e.target.dataset.eventid;

            setUniqueEventAttribute(key, value, unique, remove, eventid);

            toastSuccess('Event set to private');

        }

        else if (button === 'editVenue')
        {
            console.log('loading venue');
            let venueid = e.target.dataset.venueid;
            window.location.href = '/venue/' + venueid;

        }

        else if (button === 'editAttraction')
        {
            console.log('loading attraction');
            let attractionid = e.target.dataset.attractionid;
            window.location.href = '/attraction/' + attractionid;

        }

        else if (button === 'editEvent')
        {
            console.log('loading event');
            let attractionid = e.target.dataset.attractionid;
            window.location.href = '/event/' + attractionid;

        }


    }
    function onSelected(viewport) {
        console.log(viewport);
        setVenueData({
                         ...venueData, geo: {
                latitude: viewport.latitude, longitude: viewport.longitude
            }
                     });
    }

    return (

        <section aria-labelledby="details-heading" className="mt-12 bg-pg_blue p-2 rounded">
            {events && events.length > 0 && <div className={'mt-2'}>
                <h3 className={'text-2xl font-bold tracking-tight text-white'}>Viðburðir</h3>

                {(() => {
                    const hasPrev = !!prevOffset;
                    const hasNext = !!nextOffset;
                    const btnBase = "inline-flex items-center justify-center h-10 w-10 rounded-full shadow-sm transition";
                    const btnActive = "bg-white/10 text-white ring-1 ring-white/30 hover:bg-pg_yellow hover:text-pg_blue hover:ring-pg_yellow hover:scale-110 active:scale-95 cursor-pointer";
                    const btnDisabled = "bg-white/5 text-white/30 ring-1 ring-white/10 cursor-not-allowed";
                    return (
                <nav
                        className="flex items-center justify-between gap-2 border-t border-white/20 px-4 py-3 mt-2 mb-2 mr-4 ml-4"
                        id={'topnav'}>
                    <div className="flex w-0 flex-1">
                        <button
                                type="button"
                                onClick={() => getFirst()}
                                disabled={!hasPrev}
                                aria-label="First page"
                                className={`${btnBase} ${hasPrev ? btnActive : btnDisabled}`}
                        >
                            <ChevronDoubleLeftIcon className="h-5 w-5" aria-hidden="true"/>
                        </button>
                    </div>
                    <div className="flex items-center gap-2">
                        <button
                                type="button"
                                onClick={() => getPrevious()}
                                disabled={!hasPrev}
                                aria-label="Previous page"
                                className={`${btnBase} ${hasPrev ? btnActive : btnDisabled}`}
                        >
                            <ArrowLongLeftIcon className="h-5 w-5" aria-hidden="true"/>
                        </button>
                        <button
                                type="button"
                                onClick={() => getNext()}
                                disabled={!hasNext}
                                aria-label="Next page"
                                className={`${btnBase} ${hasNext ? btnActive : btnDisabled}`}
                        >
                            <ArrowLongRightIcon className="h-5 w-5" aria-hidden="true"/>
                        </button>
                    </div>
                    <div className="flex w-0 flex-1 justify-end"/>
                </nav>
                    );
                })()}

            </div>
            }
            <div>
                {showLoader && <>{loader()}</>}

                <div
                    className="grid grid-cols-1 md:grid-cols-2 gap-4 xl:grid-cols-2">
                    {!showLoader && events.map((event) => (<div key={event && event['@id']}>
                        {smallEventCard(event)}
                    </div>))}

                </div>

            </div>
        </section>
    )
}
